// src/plugins/i18n.js
import { createI18n } from 'vue-i18n'
import en from '../lang/en'
import th from '../lang/th'

const savedLocale = localStorage.getItem('locale') || 'th'

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: savedLocale,
  fallbackLocale: 'th',
  messages: { en, th },
  missingWarn: false,
  fallbackWarn: false,
  warnHtmlMessage: false,
})

export default i18n
